module.exports = __webpack_public_path__ + "static/media/harten.9e1fec81.svg";